import Link from "next/link";
import { cn } from "@/lib/utils";
import { topicHref } from "../lib/topics";

const PILL = "inline-flex h-6 items-center rounded-[7px] bg-neutral-100 px-2 text-xs text-neutral-600";

/**
 * `EX-TAG01`: a topic, by its name. A link to the topic page where it stands
 * on its own, plain text inside a row that is itself a link (a link inside a
 * link is not valid HTML, and the row already goes somewhere).
 */
export function TopicPill({
  tag,
  name,
  locale,
  link = true,
  className,
}: {
  tag: string;
  name: string;
  locale: string;
  link?: boolean;
  className?: string;
}) {
  if (!link) return <span className={cn(PILL, className)}>{name}</span>;
  return (
    <Link
      href={topicHref(locale, tag)}
      className={cn(
        PILL,
        "transition-colors duration-200 hover:bg-primary/10 hover:text-primary-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary",
        className,
      )}
    >
      {name}
    </Link>
  );
}
